import { Badge, Box, Grid, Heading, HStack, Text } from "@chakra-ui/layout";
import { t } from "@lingui/macro";
import { useGetProjectBudgetExceededCountQuery } from "@src/__generated__/graphql";
import {
  NavigationCard,
  type NavigationCardObject,
} from "@src/components/ui-kit/navigation-card";
import { can, cannot } from "@src/utils/components/permissions";

type Props = {
  categories: ReportCategory[];
};

export type ReportCategory = {
  title: () => string;
  reports: NavigationCardObject[];
};

export const ReportCategories = ({ categories }: Props) => {
  const { data } = useGetProjectBudgetExceededCountQuery({
    fetchPolicy: "cache-and-network",
    skip: cannot("project_viewAllFields"),
  });

  return categories.map(({ title, reports }) => (
    <Box
      mt="8"
      key={title() + reports.map((report) => report.title()).join("-")}
    >
      <Heading size="md">{title()}</Heading>
      <Grid templateColumns="repeat(3, 1fr)" mt="2" gap="5">
        {reports.map(
          (report) =>
            (!report.permissions || can(report.permissions)) && (
              <NavigationCard
                key={`${report.title()}-${report.description()}`}
                href={report.href}
                description={report.description()}
                backgroundColor={report.bg}
                title={
                  <HStack spacing="2" align="center">
                    <Text fontSize="inherit" fontWeight="inherit">
                      {report.title()}
                    </Text>
                    {report.href === "/reports/budget-exceeded" && (
                      <Badge colorScheme="red" size="sm">
                        {data?.getActiveProjectBudgetExceededCount}
                      </Badge>
                    )}
                  </HStack>
                }
                linkText={t`View report`}
                isBeta={report.isBeta ?? false}
              />
            ),
        )}
      </Grid>
    </Box>
  ));
};
